import React, { useState, useEffect, useCallback } from 'react';
import HeadSub from '../../../../components/comm/HeadSub';
import AgreeConditionsBox from '../../../../components/box/AgreeConditionsBox';
import style from './AgreeConditions.module.css';
import URL from '../../../../constants/url';
import { useLocation, useNavigate } from 'react-router-dom';

import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';
import ToastPopup from '../../../../components/comm/ToastPopup';
import ConfirmBox from '../../../../components/box/ConfirmBox';
import { getDpSnsSignin } from '../../../../assets/js/comm'

import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';
import MSG from '../../../../constants/message';


const AgreeConditions = () => {

    const navigate = useNavigate();

    const location = useLocation();
    // state : { usrNm: name, mblNo: phone, brthdy: birth, gendr: genderCode, usrSeCd: "A1", statCd: "1" }
    const { state } = location;

    // toast
    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const [policeInfo, setPoliceInfo] = useState({
        title : '',
        children  : ''
    })
    const [policeList, setPoliceList] = useState([])

    // BottomSheet
    const [open, setOpen] = useState(false);

    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        setOpen(false);
    }, []);

    function onDismiss() {
        setOpen(false);
    }

    //체크박스
    const [check1, setCheck1] = useState(false);
    const [check2, setCheck2] = useState(false);
    const [check3, setCheck3] = useState(false);
    const [checkAll, setCheckAll] = useState(false);

    const handleCheckAll = (e) => {
        const checked = e.target.checked;
        setCheck1(checked);
        setCheck2(checked);
        setCheck3(checked);
        setCheckAll(checked);
    };

    const handleCheck1 = () => {
        const newVal = !check1;
        setCheck1(newVal);
        setCheckAll(newVal && check2 && check3);
    };

    const handleCheck2 = () => {
        const newVal = !check2;
        setCheck2(newVal);
        setCheckAll(check1 && newVal && check3);
    };

    const handleCheck3 = () => {
        const newVal = !check3;
        setCheck3(newVal);
        setCheckAll(check1 && check2 && newVal);
    };


    const handleOnAgreeCheck = () => {

        if( check1 && check2 && check3 ) {
            const allTrmsAgreDt = Math.floor(Date.now() / 1000);
            // 가입처리 후 보내야 하는 URL .. 하지만.. 회원 ID/PW 생성을 안했기때문에 생성화면 이후 넘겨주도록 한다.
            //navigate(URL.MEMBERSHIP_COMPLETE);

            if(!state.provider || state.provider === 'idpw') {
                navigate(URL.SIGNUP, { state: { ...state, allTrmsAgreDt: allTrmsAgreDt }});
            } else {
                snsSignUp(allTrmsAgreDt);
            }
            /**
             * long seconds = ...; // 예: 1721856000
             * Timestamp timestamp = new Timestamp(seconds * 1000L);
             * DB : (TO_TIMESTAMP(1721856000)); 저장 필요.
             */
        } else {
            setToastMessage("서비스 이용을 위해 약관에 모두 동의해야 합니다.");
            setToast(true);
        }

    };

    useEffect(() => {
        //약관 목록 호출
        const getData = async () => {

            const url = `/signup/retrieveEnfcStplatPoliceIdList`;

            await axiosApi.post(url, {})
            .then((res) => {
                if (res.data.resultCode === CODE.RCV_SUCCESS) {
                    setPoliceList(res.data.result.result);
                } else {
                    setToastMessage(res.data.resultMessage);
                    setToast(true);
                }
            })
            .catch(err => {
                console.error("===========> 이용약관 호출 실패  : ", err);
            })
        }

        getData();

    },[]);

    const handleClickPolicBtn = useCallback((stplatPolicySeCd) => {

        const selectPolice = policeList.find((item) => item.stplatPolicySeCd === stplatPolicySeCd) ?? {};

        const isEmpty = Object.keys(selectPolice).length === 0

        if(!isEmpty) {
            setPoliceInfo({title : selectPolice.stplatPolicySj, children : selectPolice.stplatPolicyCn});
        } else {
            setPoliceInfo({title : '', children : ''});
        }
        setOpen(true);
    },[policeList])


    //////////////////////////////////idpw를 제외한 sns는 여기서 회원 가입을 시킴///////////////////////////////////////

    const [ signUsrInfo, setSignUsrInfo ] = useState({});

    const snsSignUp = useCallback(async (allTrmsAgreDt) => {

        // SIGN_UP_NAVER("12", "sign up - naver"),
        // SIGN_UP_KAKAO("13", "sign up - kakao"),
        // SIGN_UP_GOOGLE("14", "sign up - google"),
        // SIGN_UP_APPLE("15", "sign up - apple"),

        const usrSeCd = state.provider === 'naver' ? "12" : state.provider === 'kakao' ? "13" :
                        state.provider === 'google' ? "14" : state.provider === 'apple' ? "15" : "";

        const snsSignObj = {
            sns : state.provider,
            [(['naver', 'kakao'].includes(state.provider) ? 'accessToken' : 'idToken')]: state.accessToken,
            accessToken: state.accessToken,
            displayName: state.usrNm,
            phoneNumber: state.mblNo,
            email: state.emailAdres,
            birth: state.brthdy,
            gender: state.gendr,
            staff: false,
            // pushToken: "string", //앱에서만
            cid: state.encptCidVal,

        }

        const signRes = await getDpSnsSignin(snsSignObj);

        if (signRes?.accessToken !== undefined && signRes?.accessToken !== "") {

            const jToken = signRes?.accessToken;
            const refreshToken = signRes?.refreshToken;
            const requestLoginUrl = "/signup/saveUser"

            const requestOptions = {
                headers: {
                    Authorization: `Bearer ${jToken}`,
                }
            }
            const signupReq = {
                ...state, crtfcTknVal: refreshToken, usrSeCd : usrSeCd, statCd: "1", allTrmsAgreDt: allTrmsAgreDt,
            }

            // 애프터케어 서버 저장로직 완료 후 .. =>  MEMBERSHIP_COMPLETE  넘겨준다.
            axiosApi.post(requestLoginUrl, signupReq, requestOptions)
                .then((res) => {
                    console.log( "=============> aftcrUser : ", res );
                    if (Number(res.data.resultCode) === Number(CODE.RCV_SUCCESS)) {
                        const aftcrUser = res.data.result.aftcrUser;
                        sessionStorage.setItem('loginUser', JSON.stringify(aftcrUser))
                        localStorage.setItem('jToken', jToken);
                        setSignUsrInfo( { ...aftcrUser });
                        // 메뉴설정이 있다면 메뉴 설정 구간...
                        //
                        // 자동로그인 confirm 후 ok 시 설정팝업
                        setIsOpen(true);
                    } else if (Number(res.data.resultCode) === Number(CODE.RCV_FAILURE)) {
                        // failure // 실패시 ..  두종류가 있음.
                        // 1.애프터케어 계정이 존재하는 경우(이 경우 나올일이 없지만.. 데이터가 꼬인경우.)
                        // 2.애프터케어 저장실패
                        const isExistUserAt = res.data.result?.isExistAt; // true : 기생성 | false : 저장실패
                        if(isExistUserAt) {
                            console.log( " ================> RCV_FAILURE : ", res );
                            setToastMessage(MSG.ERR_DUPUSR);
                            setToast(true);
                        } else {
                            console.log( " ================> RCV_FAILURE : ", res );
                            setToastMessage(MSG.PRCS_FAILSAVE);
                            setToast(true);
                        }
                    } else { // 900 .. 입력 validation 에러
                        console.log(" =========> RCV_ERROR_VALIDATION : ", res );
                        setToastMessage(MSG.ERR_INPUTVALID);
                        setToast(true);
                    }
                })
                .catch((err) => {
                    console.log( " ================> RCV_ERROR_SERVER ", err);
                })
        } else {
            alert(MSG.ERR_PSSUSR+"\n사용자의 "+MSG.ERR_AUTH);
        }

    },[state]);

    const handleOnComplateAutoLogin = (chooseAt) => {
        if(chooseAt) {
            localStorage.setItem("AFTCR_ID", signUsrInfo.usrId);
            localStorage.setItem("AFTCR_CRTFC_TKN", signUsrInfo.crtfcTknVal);
            localStorage.setItem("AFTCR_SAVE_ID_FLAG", true);
            setIsOpen(false);
            navigate(URL.MEMBERSHIP_COMPLETE, { state : { ...signUsrInfo } });
        } else {
            setIsOpen(false);
            navigate(URL.MEMBERSHIP_COMPLETE, { state : { ...signUsrInfo } });
        }
    };

    return (
        <>
            <HeadSub title="약관 동의" />

                <div id="sub-content" data-layout="white">
                    <div className='inner-wrap' data-padding="30">

                    <div className='animation-2'>
                        <div className={style['top-box']}>
                            <div className={style['main-txt-box']}>
                                <p>안전하고 편리한 홈케어 서비스를 위해
                                <b> careplus 약관</b>을 확인하시고</p>
                                <p><b>동의</b>해주세요</p>
                            </div>
                            <div className={style['sub-txt-box']}>
                                <span>여러분의 개인정보와 서비스 이용 권리를 <br />
                                잘 지켜드리겠습니다</span>
                            </div>
                        </div>

                        <div className={style['mid-box']}>
                            <div className={style['all-agree-box']}>
                                <div className='chkbox-custom' data-chkbox='basic'>
                                    <input
                                        type="checkbox"
                                        id='all-chk'
                                        checked={checkAll}
                                        onChange={handleCheckAll}/>
                                    <label htmlFor="all-chk">
                                        <div className={style['txt-box']}>
                                        <p>모두 동의합니다.</p>
                                        <span>서비스 이용을 위해 아래 약관에 모두 동의합니다</span>
                                        </div>
                                    </label>
                                </div>

                            </div>
                            <div className={style['require-agree-box']}>
                                <ul>
                                    <li>
                                        <div className='chkbox-custom' data-chkbox='basic'>
                                            <input type="checkbox" id='require-chk1' checked={check1} onChange={handleCheck1}/>
                                            <label htmlFor="require-chk1">
                                                <div className={style['txt-box']}>
                                                <b>&#91;필수&#93;</b> <p>서비스 이용약관</p>
                                                </div>
                                            </label>
                                        </div>
                                        <button className={style['more-btn']} onClick={() => handleClickPolicBtn('A')}>
                                            <span>보기</span>
                                        </button>
                                    </li>
                                    <li>
                                        <div className='chkbox-custom' data-chkbox='basic'>
                                            <input type="checkbox" id='require-chk2' checked={check2} onChange={handleCheck2}/>
                                            <label htmlFor="require-chk2" >
                                                <div className={style['txt-box']}>
                                                <b>&#91;필수&#93;</b> <p>개인정보 수집 및 이용동의</p>
                                                </div>
                                            </label>
                                        </div>
                                        <button className={style['more-btn']} onClick={() => handleClickPolicBtn('B')}>
                                            <span>보기</span>
                                        </button>
                                    </li>
                                    <li>
                                        <div className='chkbox-custom' data-chkbox='basic'>
                                            <input type="checkbox" id='require-chk3' checked={check3} onChange={handleCheck3}/>
                                            <label htmlFor="require-chk3">
                                                <div className={style['txt-box']}>
                                                <b>&#91;필수&#93;</b> <p>민감정보 수집 및 이용 동의</p>
                                                </div>
                                            </label>
                                        </div>
                                        <button className={style['more-btn']} onClick={() => handleClickPolicBtn('C')}>
                                            <span>보기</span>
                                        </button>
                                    </li>
                                </ul>

                            </div>

                        </div>
                    </div>

                        {/* 하단 다음 버튼 영역 :: S */}
                        <div className="bottom-fixed-box">
                            <div className="inner-box">
                                <div className='btn-layout' data-btn-num="1">

                                    <button
                                        className="btn"
                                        data-btn-type="fill-main"
                                        data-btn-size="lg"
                                        onClick={() => handleOnAgreeCheck() }
                                        disabled={!(check1 && check2 && check3)}
                                    >
                                        <span>다음</span>
                                    </button>

                                </div>
                            </div>
                        </div>
                        {/* 하단 다음 버튼 영역 :: E */}


                        <BottomSheet

                            scrollLocking={false} // 내부 스크롤을 위해 BottomSheet 스크롤 잠금 해제
                            expandOnContentDrag={false} // 내용 드래그로 확장 방지

                            open={open}
                            onDismiss={onDismiss}
                            snapPoints={({ maxHeight }) => [
                                maxHeight - maxHeight / 10,
                                maxHeight * 0.6,
                              ]}
                            blocking={true}
                            className={style['header-top']}
                            >
                            <AgreeConditionsBox onClose={onDismiss} title={policeInfo.title} children={policeInfo.children}/>
                        </BottomSheet>

                        {/* 토스트 */}
                        {toast && (
                            <ToastPopup
                                setToast={setToast}
                                message={toastMessage}
                                position='center'
                            />
                        )}

                    </div>
                </div>

                <ConfirmBox isOpen={isOpen}
                    setIsOpen={setIsOpen}
                    onCloseCallback={handleOnComplateAutoLogin}
                    message={'가입이 완료되었습니다.\n자동로그인을 설정할까요?'}
                    leftBtnTxt={'아니오'}
                    rightBtnTxt={'네'} />
        </>
    )
}

export default AgreeConditions
